export type WorldId =
  | 'pacman-2d'
  | 'pacman-physics-game'
  | 'pacman-animations-game'
  | 'pacman-sahara'
  | 'pacman-amazon'
  | 'pacman-atlantic'
  | 'pacman-antarctica'
  | 'pacman-space'
  | 'pacman-muddy';

export const WORLDS_ORDER: WorldId[] = [
  'pacman-2d',
  'pacman-physics-game',
  'pacman-animations-game',
  'pacman-sahara',
  'pacman-amazon',
  'pacman-atlantic',
  'pacman-antarctica',
  'pacman-space',
  'pacman-muddy',
];

const STORAGE_KEY = 'pacman_unlocked_count_v1';

export function getUnlockedCount(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? parseInt(raw, 10) : 1;
    return Number.isNaN(parsed) || parsed < 1
      ? 1
      : Math.min(parsed, WORLDS_ORDER.length);
  } catch {
    return 1;
  }
}

export function setUnlockedCount(count: number): void {
  try {
    const clamped = Math.max(1, Math.min(count, WORLDS_ORDER.length));
    localStorage.setItem(STORAGE_KEY, String(clamped));
  } catch {
    // ignore persistence errors
  }
}

export function unlockNextAfter(worldId: WorldId): number {
  const current = getUnlockedCount();
  const index = WORLDS_ORDER.indexOf(worldId);
  if (index === -1) return current;
  const needed = index + 2; // unlock next index
  const next = Math.max(current, needed);
  setUnlockedCount(next);
  return next;
}
